import { Theme } from "@mui/material";
import { alpha } from "@mui/system";

const useStyles = (theme: Theme) => ({
  textDataPicker: {
    fontSize: "0.875rem",
    fontWeight: 500,
    fontColor: theme.palette.text.primary,
  },
  titleDataPicker: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  dataTime: {
    actionBar: {
      actions: ["accept"],
      sx: {
        "& .MuiButton-root": {
          color: theme.palette.text.primary, // Cor do texto
          backgroundColor: "transparent", // Cor de fundo
          "&:hover": {
            backgroundColor: alpha(theme.palette.text.primary, 0.05), // Cor de fundo ao passar o mouse
          },
        },
      },
    },
    accept: {
      sx: {
        backgroundColor: "#4CAF50", // Cor verde para o botão Aceitar
        color: "white",
        "&:hover": {
          backgroundColor: "#45a049", // Cor verde mais escuro no hover
        },
        borderRadius: "5px",
      },
    },
    digitalClockSectionItem: {
      sx: {
        borderRadius: "4px",
        "&.Mui-selected": {
          // backgroundColor: theme.palette.text.primary,
          // color: theme.palette.text.inverted,
        },
        "&.Mui-selected:hover": {
          // backgroundColor: theme.palette.text.secondary,
        },
      },
    },
    day: {
      sx: {
        "&.Mui-selected:focus": {
          // backgroundColor: theme.palette.text.primary, // Mantém a cor ao clicar
        },
        "&.Mui-selected": {
          // backgroundColor: theme.palette.text.primary,
          // color: theme.palette.text.inverted,
          fontWeight: 500,
        },
        "&.Mui-selected:hover": {
          //backgroundColor: theme.palette.text.secondary,
        },
      },
    },
    desktopPaper: {
      sx: {
        backgroundColor: theme.palette.background.default,
        boxShadow: "0px 0px 4px 0px  rgba(0, 0, 0, 0.25)",
      },
    }, // Para desktop
    mobilePaper: {
      sx: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: "0px 0px 4px 0px  rgba(0, 0, 0, 0.25)",
      },
    }, // Para mobile
    textField: { variant: "filled" },
  },
  menuList: { height: "124px", overflow: "auto" },
  menuItem: {
    fontSize: "0.875rem",
    fontWeight: 500,
    "&:hover": {
      backgroundColor: alpha(theme.palette.background.textField, 0.4),
    },
    borderRadius: 1,
    "&.Mui-selected": {
      color: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
      "&:hover": {
        backgroundColor: alpha(theme.palette.primary.main, 0.2),
      },
    },
  },
  paperPoover: {
    "& .MuiPopover-paper": {
      marginTop: "5px",
      boxShadow: "0px 4px 14px 0px  #0000002c",
      padding: "10px",
      overflow: "visible",
      borderRadius: 1,
    },
  },
});

export default useStyles;
